import { useMemo } from "react";
import { feedback__SentimentType } from "@medbillai/graphql-types";
import { Paragraph, XStack, YStack } from "@medbillai/ui";
import type { FeedbackOption } from "../types";
import OptionItem from "./OptionItem";
type Props = {
  options: FeedbackOption[];
  selectedOptionIds: Set<string>;
  onPressOption: (option: FeedbackOption) => void;
  rating?: number;
};
export default function OptionsGroup({
  options,
  selectedOptionIds,
  onPressOption,
  rating
}: Props) {
  const filteredOptions = useMemo(() => {
    switch (rating) {
      case 1:
        return options.filter(option => option.sentiment === feedback__SentimentType.NEGATIVE);
      case 2:
        return options.filter(option => option.sentiment !== feedback__SentimentType.POSITIVE);
      case 3:
        return options.filter(option => option.sentiment === feedback__SentimentType.NEUTRAL);
      case 4:
        return options.filter(option => option.sentiment !== feedback__SentimentType.NEGATIVE);
      case 5:
        return options.filter(option => option.sentiment === feedback__SentimentType.POSITIVE);
      default:
        return options;
    }
  }, [options, rating]);
  return <YStack data-sentry-element="YStack" data-sentry-component="OptionsGroup" data-sentry-source-file="OptionsGroup.tsx">
      <Paragraph bold pb="$3" data-sentry-element="Paragraph" data-sentry-source-file="OptionsGroup.tsx">
        Choose all that apply
      </Paragraph>
      <XStack flexWrap="wrap" marginHorizontal="$-2" pb="$4" data-sentry-element="XStack" data-sentry-source-file="OptionsGroup.tsx">
        {/** Maximum of 6 options to display for screen space */}
        {filteredOptions.slice(0, 6).map(option => <YStack key={option.id} width="50%" padding="$2">
            <OptionItem option={option} selected={selectedOptionIds.has(option.id)} onPress={onPressOption} />
          </YStack>)}
      </XStack>
    </YStack>;
}